/**
 * Auth Module
 */
import Vue from 'vue'
import Nprogress from 'nprogress'
import router from '@/router'


// state
const state = {
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
    tokensMIPRES: localStorage.getItem('tokensMIPRES') ? JSON.parse(localStorage.getItem('tokensMIPRES')) : {mipres: null, suministros: null, facturacion: null, mipres_facturacion: null}
}

// getters
const getters = {
    getUser: state => {
        return state.user
    },
    activesMenus: state => {
        return (!!state.tokensMIPRES.mipres && !!state.tokensMIPRES.mipres.token && !!state.tokensMIPRES.suministros && !!state.tokensMIPRES.suministros.token)
    },
    getPermission: state => PermissionString => {
        return state.user && state.user.permissions && !!state.user.permissions.find(x => x.name === PermissionString)
    },
    getPermissionModule: state => modulo => {
        if (state.user && state.user.permissions) {
            return state.user.permissions.filter(x => x.name.toString().toLowerCase().indexOf(modulo.toString().toLowerCase()) > -1).map(x => x.name.split(`${modulo}.`)[1]).reduce((value, key) => {
                value[key] = value[key] || true
                return value
            }, {})
        } else {
            return {}
        }
    },
    typeEmpresa: state => {
        return state.user ? state.user.empresa.tipo_empresa : null
    }
}

// actions
const actions = {
    async signinUser(context, payload) {
        const { user } = payload
        Nprogress.start()
        let respuestaLogin = await new Promise((resolve, reject) => {
            Vue.axios.post(`login`, user)
                .then(response => {
                    context.commit('loginUserSuccess', response.data)
                    context.commit('assignTokenAxios')
                    Nprogress.done()
                    resolve(true)
                })
                .catch(e => {
                    Nprogress.done()
                    reject(e)
                })
        })
        if (respuestaLogin) {
            let respuestaTokensMIPRES = await context.dispatch('getTokensMIPRES')
            router.push({name: respuestaTokensMIPRES ? 'Dashboard' : 'Mipres'})
            return respuestaLogin
        }
        return respuestaLogin
    },
    async getTokensMIPRES(context) {
        return await new Promise((resolve, reject) => {
            Vue.axios.get(`webservices`)
                .then(response => {
                    context.commit('assignTokenMIPRES', response.data)
                    resolve(true)
                })
                .catch(e => {
                    resolve(false)
                })
        })
    },
    refreshToken(context) {
        return new Promise(resolve => {
            Vue.axios.get('login/refresh')
                .then(response => {
                    if (response.data.refresh_token && context.state.user && context.state.user.token_type) {
                        context.commit('refreshToken', response.data.refresh_token)
                        context.commit('assignTokenAxios')
                        resolve(`${context.state.user.token_type} ${response.data.refresh_token}`)
                    } else {
                        resolve(false)
                    }
                }).catch(e => {
                resolve(false)
                })
        })
    },
    logoutUser(context) {
        Nprogress.start()
        setTimeout(() => {
            Nprogress.done()
            context.commit('logoutUser')
        }, 1000)
    }
}

// mutations
const mutations = {
    loginUser(state) {
        Nprogress.start()
    },
    assignTokenMIPRES(state, tokens) {
        let tokensMipres = {
            mipres: !!tokens.find(x => x && x.webservice === 'mipres') ? tokens.find(x => x.webservice === 'mipres') : null,
            suministros: !!tokens.find(x => x && x.webservice === 'suministros') ? tokens.find(x => x.webservice === 'suministros') : null,
            facturacion: !!tokens.find(x => x && x.webservice === 'facturacion') ? tokens.find(x => x.webservice === 'facturacion') : null,
            mipres_facturacion: !!tokens.find(x => x && x.webservice === 'mipres_facturacion') ? tokens.find(x => x.webservice === 'mipres_facturacion') : null
        }
        localStorage.setItem('tokensMIPRES', JSON.stringify(tokensMipres))
        state.tokensMIPRES = JSON.parse(localStorage.getItem('tokensMIPRES'))
    },
    assignTokenAxios(state) {
        const dataStorage = JSON.parse(localStorage.getItem('user'))
        if (dataStorage) Vue.axios.defaults.headers.common['Authorization'] = dataStorage.token_type + ' ' + dataStorage.access_token
    },
    refreshToken(state, token) {
        let userStorage = JSON.parse(localStorage.getItem('user'))
        userStorage.access_token = token
        localStorage.setItem('user', JSON.stringify(userStorage))
        state.user = userStorage
    },
    loginUserReauth(state) {
        let userStorage = JSON.parse(localStorage.getItem('user'))
        if (userStorage) {
            userStorage.access_token = null
            localStorage.setItem('user', JSON.stringify(userStorage))
            state.user = JSON.parse(localStorage.getItem('user'))
        }
        if (userStorage && userStorage.user && userStorage.user.email) {
            router.push('/session/lock-screen')
        } else {
            router.push('/session/login')
        }
    },
    loginUserSuccess(state, user) {
        localStorage.setItem('user', JSON.stringify(user))
        state.user = JSON.parse(localStorage.getItem('user'))
    },
    logoutUser(state) {
        localStorage.removeItem('user')
        state.user = null
        router.push('/session/login')
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
